import React from 'react'
import CustomerProfile from '../components/customerProfile/CustomerProfile'

export default function CustomerProfilePage() {
  return (
    <div>
      <CustomerProfile/>
    </div>
  )
}
